import React, { PropsWithChildren } from 'react'
import Footer from './components/Footer/Footer'
import Header from './components/Header/Header'

const Layout: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
    return (
        <div>
            <Header />
            <div className='App'>
                <section className='App-content'>{children}</section>
                <Footer></Footer>
            </div>
        </div>
    )
}
export default Layout
